module.exports = __webpack_public_path__ + "static/Grupo538-51cfb700a916f49bb10c6c29a7fcc246.png";